/** @format */

const endpoint = {
    URL_SEND_CODE: "v3.0/code-new-ios",
	URL_GET_INFO: "v3.0/profile",
};
export default endpoint;
